import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import {
  Box, Typography, Tabs, Tab, Paper, Divider,
  Grid, Card, CardContent, Table, TableHead,
  TableRow, TableCell, TableBody, TextField, Switch, FormControlLabel
} from '@mui/material';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { db } from '../../firebase';

export default function BankDetail() {
  const location = useLocation();
  const bank = location.state;
  const [tab, setTab] = useState(0);
  const [properties, setProperties] = useState([]);
  const [epayEnabled, setEpayEnabled] = useState(true);

  useEffect(() => {
    const fetchProperties = async () => {
      if (!bank?.id) return;
      const q = query(collection(db, 'properties'), where('bankAccount', '==', bank.id));
      const snapshot = await getDocs(q);
      const props = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setProperties(props);
    };
    fetchProperties();
  }, [bank?.id]);

  const handleTabChange = (_, newValue) => setTab(newValue);

  if (!bank) return <Typography>Bank account not found.</Typography>;

  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h5" gutterBottom>{bank.name}</Typography>
      <Typography variant="subtitle1" gutterBottom>****{bank.last4} • {bank.type}</Typography>

      <Tabs value={tab} onChange={handleTabChange} sx={{ mb: 3 }}>
        <Tab label="Payment Settings" />
        <Tab label="Properties" />
      </Tabs>

      <Grid container spacing={3}>
        <Grid item xs={12} md={8}>
          {tab === 0 && (
            <Box>
              <Typography variant="h6" gutterBottom>Payment Settings</Typography>
              <Paper elevation={3} sx={{ p: 3, borderRadius: 2 }}>
                <FormControlLabel
                  control={<Switch checked={epayEnabled} onChange={() => setEpayEnabled(!epayEnabled)} />}
                  label="Enable ePay for this bank account"
                />
                <Divider sx={{ my: 2 }} />
                <Typography variant="subtitle2" sx={{ mb: 1 }}>Check printing information</Typography>
                <TextField
                  fullWidth
                  label="Company name"
                  value="Memphis Passive LLC"
                  sx={{ mb: 2 }}
                />
                <TextField
                  fullWidth
                  label="Bank name"
                  value={bank.name}
                  sx={{ mb: 2 }}
                />
                <TextField
                  fullWidth
                  label="Memo text"
                  value="Operating Account"
                  sx={{ mb: 2 }}
                />
                <Divider sx={{ my: 2 }} />
                <Typography variant="subtitle2" sx={{ mb: 1 }}>Company Information</Typography>
                <TextField
                  fullWidth
                  label="Company EIN"
                  value="82-1189338"
                  sx={{ mb: 2 }}
                />
                <TextField
                  fullWidth
                  label="Business Type"
                  value="LLC"
                  sx={{ mb: 2 }}
                />
              </Paper>
            </Box>
          )}

          {tab === 1 && (
            <Box>
              <Typography variant="h6" gutterBottom>Linked Properties</Typography>
              <Paper elevation={3} sx={{ p: 2, borderRadius: 2 }}>
                {properties.length === 0 ? (
                  <Typography>No properties are linked to this bank account yet.</Typography>
                ) : (
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell><strong>Address</strong></TableCell>
                        <TableCell><strong>City</strong></TableCell>
                        <TableCell><strong>State</strong></TableCell>
                        <TableCell><strong>ZIP</strong></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {properties.map((p) => (
                        <TableRow key={p.id}>
                          <TableCell>{p.street}</TableCell>
                          <TableCell>{p.city}</TableCell>
                          <TableCell>{p.state}</TableCell>
                          <TableCell>{p.zip}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                )}
              </Paper>
            </Box>
          )}
        </Grid>

        <Grid item xs={12} md={4}>
          <Card elevation={3} sx={{ borderRadius: 2 }}>
            <CardContent>
              <Typography variant="subtitle2" color="text.secondary">Bank account</Typography>
              <Typography>Merchant ID: {bank.merchantId || '282588'}</Typography>
              <Typography>Vendor Merchant ID: {bank.vendorMerchantId || '389591'}</Typography>
              <Divider sx={{ my: 2 }} />
              <Typography variant="subtitle2" color="text.secondary">Service fees</Typography>
              <Typography variant="body2">Incoming ACH: $0.99</Typography>
              <Typography variant="body2">Outgoing ACH: $0.50</Typography>
              <Typography variant="body2">Credit Cards: 2.99%</Typography>
              <Divider sx={{ my: 2 }} />
              <Typography variant="subtitle2" color="text.secondary">Incoming payment limits</Typography>
              <Typography variant="body2">Per deposit: $2,000</Typography>
              <Typography variant="body2">Per month: $40,000</Typography>
              <Typography variant="body2">Remaining for this month: $36,378.87</Typography>
              <Divider sx={{ my: 2 }} />
              <Typography variant="subtitle2" color="text.secondary">Outgoing payment limits</Typography>
              <Typography variant="body2">Per withdrawal: $5,000</Typography>
              <Typography variant="body2">Per month: $20,000</Typography>
              <Typography variant="body2">Remaining for this month: $20,000.00</Typography>
              <Divider sx={{ my: 2 }} />
              <Typography variant="subtitle2" color="text.secondary">Hold days</Typography>
              <Typography variant="body2">Incoming: 1 day</Typography>
              <Typography variant="body2">Outgoing: 1 day</Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
}